package com.dotdrives.web.ui

import com.dotdrives.design.DotTone
import react.FC
import react.Props
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface DotBannerProps : Props {
    var message: String
    var onRetry: (() -> Unit)?
    var tone: DotTone?
    var className: String?
}

val DotBanner = FC<DotBannerProps> { props ->
    val tone = props.tone ?: DotTone.Danger
    div {
        className = ClassName(
            listOfNotNull(
                "dot-banner",
                "dot-tone-${tone.classSuffix()}",
                props.className,
            ).joinToString(" "),
        )
        role = "alert".unsafeCast<AriaRole>()
        div {
            className = ClassName("dot-banner-dot")
        }
        div {
            className = ClassName("dot-banner-message dot-body")
            +props.message
        }
        if (props.onRetry != null) {
            button {
                type = ButtonType.buttonType
                className = ClassName("dot-banner-retry")
                onClick = { props.onRetry?.invoke() }
                +"Retry"
            }
        }
    }
}
